import { render, staticRenderFns } from "./ImageLink.vue?vue&type=template&id=000d8968&scoped=true"
import script from "./ImageLink.vue?vue&type=script&lang=js"
export * from "./ImageLink.vue?vue&type=script&lang=js"
import style0 from "./ImageLink.vue?vue&type=style&index=0&id=000d8968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d8968",
  null
  
)

export default component.exports